export default __webpack_public_path__ + "static/brands-lead-bg@1x-18fb8b71a8b63c3125acf7d615dad8b4.jpg";